<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div class="modal-body">
                  <h2 class="title">Register New User</h2>
                  <form>
                    <div class="row row-space">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Full Name<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text" name="name" v-model="form.fullName">
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Username<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text" name="username" v-model="form.username">
                        </div>
                      </div>
                    </div>
                    <div class="row row-space">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Password<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="password" name="password" v-model="form.password">
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Re-type Password<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="password" name="retype_password" v-model="retype_password">
                        </div>
                      </div>
                    </div>
                    <div class="row row-space">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">User Type<span style="color: red;">*</span></label>
                          <MultiSelect v-model="form.type"
                          :options="options.type"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                          :multiple="false"
                          :allow-empty="false"
                          placeholder="Choose User Type"></MultiSelect>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label" :style="(form.type == 'ADMIN' || form.type == 'SUPER ADMIN') ? 'opacity : 0.7' : 'opacity : 1'">Dealer View Access<span v-if="form.type=='USER DEALER'" style="color: red;">*</span></label>
                          <MultiSelect v-model="selected.dealer"
                          :options="options.dealer"
                          track-by="code"
                          label="name"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                          :multiple="true"
                          :disabled="(form.type == 'ADMIN' || form.type == 'SUPER ADMIN') ? true : false"
                          :placeholder="(form.type == 'ADMIN' || form.type == 'SUPER ADMIN' || form.type == 'USER MAIN DEALER') ? 'All Dealers' : 'Select Dealers'"></MultiSelect>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <label class="label text-left">Module<span style="color: red;">*</span></label>
                    </div>
                    <div class="row" v-if="moduleConfig != null">
                      <!-- Module Selection Starts -->
                      <div v-for="(module, index) in structure" class="innerBox w-100 mt-3" 
                        :class="[(module.children != null) ? 'hoverable' : ''].join(' ')" 
                        @click="openBox(index)">
                        
                        <div class="row">
                          <div class="custom-control custom-checkbox align-middle" :class="(mobile) ? 'col-8' : 'col-4'" style="padding-left:35px">
                            <input v-if="module.children == null" type="checkbox" class="custom-control-input" :id="'new-module-' + module.id" :value="module.id" v-model="selectedModules[index]" :disabled="form.type == 'ADMIN'">

                            <input v-else type="checkbox" class="custom-control-input" :id="'new-module-' + module.id" v-indeterminate="moduleConfig[index].indeterminate" v-model="moduleConfig[index].checked" @change="selectAll(index)" :disabled="form.type == 'ADMIN'">
  
                            <label class="custom-control-label" :for="'new-module-' + module.id">
                              <h4 style="margin: 0">{{ module.moduleName || module.title }}</h4>
                            </label>
                          </div>
                          <div class="text-right" :class="(mobile) ? 'col-4' : 'col-8'">
                            <i v-if="module.children != null" class="fas fa-angle-right" :class="(moduleConfig[index].boxOpen) ? 'fa-rotate-90' : ''" style="font-size: 150%;"></i>
                          </div>
                        </div>
                        <hr v-if="module.children != null && moduleConfig[index].boxOpen">
                        <!-- Children Start -->
                        <div v-if="module.children != null && moduleConfig[index].boxOpen" class="row ml-3" @click.stop>
                          <div v-for="littleModule in module.children" class="col-12 mt-2 custom-control custom-checkbox little-modules align-middle" style="padding-left:35px">
  
                            <input
                              type="checkbox"
                              v-model="selectedModules[index]"
                              class="custom-control-input"
                              :value="littleModule.id"
                              :id="'new-module-' + littleModule.id"
                              :disabled="form.type == 'ADMIN'"
                              @change="select(index)"
                            >
                            <label class="custom-control-label" :for="'new-module-' + littleModule.id">{{ littleModule.moduleName || littleModule.title }}</label>
                          </div>
                        </div>
                        <!-- Children End -->
                      </div>
                      <!-- Module Selection Ends -->
                      <!-- <button class="btn btn-primary" type="button" @click="form.modules.push('Work Order Listing')">a</button> -->
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Cancel</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Register</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        let user = this.$store.getters.currentUser
        
        return{
          mobile : this.isMobile(),
          options : {
            type : user.role == 'ADMIN' || user.role == 'SUPER ADMIN' ? ['ADMIN', 'USER MAIN DEALER', 'USER DEALER', 'USER SE'] : ['USER DEALER'],
            dealer : [],
          },
          selected : {
            dealer : []
          },
          form : {
            fullName : '',
            username : '',
            password : '',
            type : 'USER DEALER',
            permission : [],
            modules : [],
          },
          retype_password : '',
          moduleConfig : null,
          selectModule : [],
          structure : [],
          selectedModules : []
        }
      },
      directives: {
        indeterminate: function(el, binding) {
          el.indeterminate = Boolean(binding.value)
        }
      },
      components:{
        MultiSelect,
      },
      mounted () {
        this.getOptionFilters();
        this.generateStructure();
      },
      watch : {
        'selected.dealer' : function(){
          var dealers = [];

          for(var i = 0; i < this.selected.dealer.length; i++){
            dealers.push(this.selected.dealer[i].code);
          }

          this.form.permission.length = 0;
          this.form.permission = this.form.permission.concat(dealers);
        },
        'form.type' () {
          this.generateStructure();
        },
      },
      methods : {
        getOptionFilters(){
          this.options.dealer = this.$store.getters.getDealer();
        },
        openBox(index){
          if(this.structure[index].children == null) return
          for(var i in this.moduleConfig){
            if(i == index)
              this.moduleConfig[index].boxOpen = !this.moduleConfig[index].boxOpen
            else
              this.moduleConfig[i].boxOpen = false
          }
        },
        selectAll(item){
          this.selectedModules[item] = []
          if(this.moduleConfig[item].checked){
            this.selectedModules[item] = this.selectedModules[item].concat(this.structure[item].children.map(x => x.id))
          }
          this.moduleConfig[item].indeterminate = false;
        },
        select(item){
          this.moduleConfig[item].checked = false;
          if(this.selectedModules[item].length == 0){
            this.moduleConfig[item].indeterminate = false;
          } else if (this.selectedModules[item].length == this.structure[item].children.length){
            this.moduleConfig[item].indeterminate = false;
            this.moduleConfig[item].checked = true;
          } else {
            this.moduleConfig[item].indeterminate = true;
          }
        },
        concatModules(){
          this.form.modules.length = 0;
          for(var i = 0; i < this.selectedModules.length; i++){
            this.form.modules = this.form.modules.concat(this.selectedModules[i]);
          }
          // console.log(JSON.stringify(this.form.modules));
        },
        generateStructure(){
          // console.log(this.$store.state.modules.length);
          this.structure = JSON.parse(JSON.stringify(this.$store.state.modules)).filter(x=>x.dealer_access==(this.form.type == 'USER DEALER' ? 1 : 0));
          
          // Remove children with path '/qr-code/distribution-monitoring/' for USER SE
          for (let i = 0; i < this.structure.length; i++) {
            const item = this.structure[i];
            if (item.children && Array.isArray(item.children)) {
              for (let j = item.children.length - 1; j >= 0; j--) {
                const child = item.children[j];
                if (!child || !child.path) continue;
                
                if (this.form.type === 'USER SE' && (child.path === '/qr-code/distribution-monitoring' || child.path === '/qr-code/qr-receipt')) {
                  item.children.splice(j, 1);
                }
                if (this.form.type !== 'USER SE' && child.path === '/qr-code/distribution-monitoring-se') {
                  item.children.splice(j, 1);
                }
              }
            }
            this.structure[i] = item;
          }
          this.generateModuleConfig()
        },
        async generateModuleConfig(){
        /**
         * Generates an array of configuration objects for the module selection.
         * Each module will have a configuration object with the following properties:
         * - boxOpen: whether the module selection box is open or not
         * - checked: whether the module is checked or not
         * - indeterminate: whether the module selection checkbox is indeterminate or not
         * 
         * @return {Promise<void>}
         */
          var moduleConfig = []
          for(var i = 0; i < this.structure.length; i++){
            this.selectedModules[i] = []
            moduleConfig.push({
              boxOpen : false,
              checked : false,
              indeterminate : false
            })
          }
          this.moduleConfig = moduleConfig
        },
        validateForm(){
          var valid = true;
          var error = [];

          if(this.form.fullName == '' || this.form.fullName == null){//Full Name [Required]
            valid = false;
            error.push('Full Name is a required Field!');
          }

          if(this.form.username == '' || this.form.username == null){//Username [Required]
            valid = false;
            error.push('Username is a required Field!');
          }

          if(this.form.password == '' || this.form.password == null){//Password [Required]
            valid = false;
            error.push('Password is a required Field!');
          }

          if(this.retype_password == '' || this.retype_password == null){//Retype Password [Required]
            valid = false;
            error.push('Retype Password is a required Field!');
          } else {
            if(this.form.password !== this.retype_password){//Password and Retype Password Not The Same
              valid = false;
              error.push('Password and Re-Type Password does not match!');
            }
          }

          if(this.form.type == '' || this.form.type == null){//Type [Required]
            valid = false;
            error.push('Type is a required Field!');
          }
          
          if(this.form.permission.length == 0){//Permission [Required for dealer]
            if(this.form.type != 'ADMIN' && this.form.type != 'SUPER ADMIN' && this.form.type != 'USER MAIN DEALER'){
              valid = false;
              error.push('Permission is a required Field!');
            } else {
              this.form.permission.push('All');
            }
          }
            
          if(this.form.modules.length == 0 && this.form.type != 'ADMIN'){//Modules [Required]
            valid = false;
            error.push('Modules has to have at least one module selected');
          }

          if(!valid) this.$emit('triggerAlert', !valid, error);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          await this.concatModules();
          if(vm.validateForm()){
            this.$http.post('/api/user/userDashboardRegister', this.form)
            .then((resp)=>{
              // alert(`Partshop ${vm.form.name} has been created`);
              vm.$emit('triggerAlert', false, [`${vm.form.type} ${vm.form.username} has been created`]);
            })
            .catch((err)=>{
              console.log(err);
              vm.$emit('triggerAlert', true, (String(err).split("Error:"))[1].split("; "));
            })
          }
        },
      }
    }
  </script>
  
  <style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
  
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
  
    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
  
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }
  
    .modal-body {
        margin: 20px 0;
    }
  
    .modal-default-button {
        float: right;
    }
  
    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */
  
    .modal-enter {
        opacity: 0;
    }
  
    .modal-leave-active {
        opacity: 0;
    }
  
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
  
    /* MODAL STARTS */
    .modal-body{
        margin:0
    }
  
    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }
  
    .modal-body .moduleLine a{
        text-decoration: none;
    }
  
    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }
  
    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }
  
    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }
  
    h3.modalHeadline{
        margin:0 0 20px 0;
        font-weight: bold;
        text-align : center;
    }
    /* MODAL ENDS */
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
     #TITLE made by Colorlib (https://colorlib.com)
     ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  
  
  


  .modal-body{
    max-height: 80vh;
    overflow-y:auto;
    overflow-x:auto;
  }
  .innerBox{
    padding: 0.8em 1.5em;
    border: 1px solid #EEEEEE;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #E0E0E0;
  }
  .custom-control{
    margin-bottom: 0;
  }
  .little-modules{
    padding: 0 10px 0 35px;
  }

  .hoverable:hover{
    cursor: pointer;
  }
  </style>
  